var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiimages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33289 7.33268V1.99935C7.33289 1.26298 7.92984 0.666016 8.66622 0.666016H25.9996C26.736 0.666016 27.3329 1.26298 27.3329 1.99935V19.3327C27.3329 20.0691 26.736 20.666 25.9996 20.666H20.6665V25.9893C20.6665 26.7312 20.0678 27.3327 19.3232 27.3327H2.00954C1.26765 27.3327 0.666504 26.7341 0.666504 25.9893L0.670184 8.67599C0.670344 7.93411 1.2689 7.33268 2.0135 7.33268H7.33289ZM9.99956 7.33268H19.3234C20.0652 7.33268 20.6665 7.93124 20.6665 8.67599V17.9993H24.6662V3.33268H9.99956V7.33268ZM3.33657 9.99935L3.33345 24.666H17.9998V9.99935H3.33657Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiimages);
export default __webpack_public_path__ + "static/media/multiimages.3b349b7aff0063de5baccd8613a8c5a7.svg";
export { ForwardRef as ReactComponent };